import * as types from '../mutation-types'
import { getData, getApiData } from '../../http'

export default {
	state: {
		boxGroupList: undefined,
		categoryList: {
			data: undefined,
			meta: {}
		},
		categories: undefined,
		caseList: {
			data: undefined,
			meta: {}
		},
		userList: {
			data: undefined,
			meta: {}
		},
		paymentList: {
			data: undefined,
			meta: {}
		},
		paymentsList: undefined,
		paymentSetting: undefined,
		paySwitches: undefined,
		roomList: {
			data: undefined,
			meta: {}
		},
		synthesisList: undefined,
		extractOrderList: {
			data: undefined,
			amount: undefined,
			meta: {}
		},
		userScoreRules: {
			data: undefined,
			meta: {}
		},
		userExpRules: {
			data: undefined,
			meta: {}
		},
		articleList: [],
		articleListMeta: {},
		keywords: []
	},
	getters: {
		boxGroupList: state => state.boxGroupList,
		paySwitches: state => state.paySwitches,
		paymentsList: state => state.paymentsList,
		keywords: state => state.keywords
	},
	mutations: {
		[types.GET_BOX_GROUP](state, payload) {
			state.boxGroupList = payload
		},
		[types.GET_CATEGORY_LIST](state, payload) {
			state.categoryList.data = payload.data
			state.categoryList.meta = payload.meta
		},
		[types.GET_CATEGORIES](state, payload) {
			state.categories = payload
		},
		[types.GET_CASE_LIST](state, payload) {
			state.caseList.data = payload.data
			state.caseList.meta = payload.meta
		},
		[types.GET_USER_LIST](state, payload) {
			state.userList.data = payload.data
			state.userList.meta = payload.meta
		},
		[types.GET_PAYMENT_LIST](state, payload) {
			state.paymentList.data = payload.data
			state.paymentList.meta = payload.meta
		},
		[types.GET_PAYMENTS_LIST](state, payload) {
			state.paymentsList = payload
		},
		[types.GET_PAYMENT_SETTING](state, payload) {
			state.paymentSetting = payload.data
		},
		[types.GET_PAY_SWITCHES](state, payload) {
			state.paySwitches = payload
		},
		[types.GET_ROOM_LIST](state, payload) {
			state.roomList.data = payload.data
			state.roomList.meta = payload.meta
		},
		[types.GET_SYNTHESIS_LIST](state, payload) {
			state.synthesisList = payload
		},
		[types.GET_EXTRACT_ORDER_LIST](state, { data, meta, amount }) {
			state.extractOrderList = { data, meta, amount }
		},
		[types.GET_ARTICLE_LIST](state, payload) {
			state.articleList = payload.data
			state.articleListMeta = payload.meta
		},
		[types.GET_KEYWORDS](state, payload) {
			state.keywords = payload.data
		}
	},
	actions: {
		// async getBoxGroupList({ commit }, params = {}) {
		// 	const res = await getData('box_groups', params)
		// 	res && commit(types.GET_BOX_GROUP, res)
		// },
		getBoxGroupList({ commit }, params = {}) {
			return new Promise(async (resolve, reject) => {
				try {
					const res = await getData('box_groups', params)
					commit(types.GET_BOX_GROUP, res)
					resolve(res)
				} catch (e) {
					reject(e)
				}
			})
		},
		async getCategoryList({ commit }, params = {}) {
			const res = await getData('category', params)
			res && commit(types.GET_CATEGORY_LIST, res)
		},
		async getCategories({ commit }, params = { page: 1, per_page: 9999 }) {
			const res = await getData('category', params)
			res && commit(types.GET_CATEGORIES, res.data)
		},
		async getCaseList({ commit }, params = {}) {
			const res = await getData('box', params)
			res && commit(types.GET_CASE_LIST, res)
		},
		async getUserList({ commit }, params) {
			const res = await getData('users', params)
			res && commit(types.GET_USER_LIST, res)
		},
		async getPaymentList({ commit }, params = {}) {
			const res = await getData('pay', params)
			res && commit(types.GET_PAYMENT_LIST, res)
		},
		async getPaymentsList({ commit }, params = {}) {
			const res = await getApiData('pay_configs', params)
			res && commit(types.GET_PAYMENTS_LIST, res)
		},
		async getPaymentSetting({ commit }) {
			const res = await getData('pay_config')
			res && commit(types.GET_PAYMENT_SETTING, res)
		},
		async getPaySwitches({ commit }) {
			const res = await getApiData('pay_switches')
			res && commit(types.GET_PAY_SWITCHES, res)
		},
		async getRoomList({ commit }) {
			const res = await getData('rooms')
			res && commit(types.GET_ROOM_LIST, res)
		},
		async getSynthesisList({ commit }, params) {
			const res = await getData('props_synthesis', params)
			res && commit(types.GET_SYNTHESIS_LIST, res.data)
		},
		async getExtractOrderList({ commit }, params) {
			const res = await getData('extract', params)
			res && commit(types.GET_EXTRACT_ORDER_LIST, res)
		},
		async getArticleList({ commit }, params) {
			const res = await getData('articles', params)
			res && commit(types.GET_ARTICLE_LIST, res)
		},
		async getKeywords({ commit }) {
			const res = await getApiData('zbt_keywords')
			res && commit(types.GET_KEYWORDS, res)
		}
	}
}
